import WebRoutes from './WebRoutes';

export default WebRoutes;
